import { DimensionsViewModel } from "src/app/view-models/orders/dimensions.view-model";
import { StoredDimensions } from "../models/stored-orders/stored-dimensions";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between Dimensions view model and database StoredDimensions.
 */
export class DimensionsMapper implements IStoredMapper<DimensionsViewModel, StoredDimensions> {
	/**
	 * Maps a Dimensions to a StoredDimensions.
	 * @param dimensions The dimensions data to convert.
	 * @returns A StoredDimensions object.
	 */
	public ToStored(dimensions: DimensionsViewModel): StoredDimensions {
		return {
			Weight: dimensions.Weight,
			Height: dimensions.Height,
			Length: dimensions.Length,
			Width: dimensions.Width
		};
	}

	/**
	 * Maps a StoredDimensions to a Dimensions.
	 * @param storedDimensions The stored dimensions data to convert.
	 * @returns A Dimensions object.
	 */
	public FromStored(storedDimensions: StoredDimensions): DimensionsViewModel {
		return {
			Weight: storedDimensions.Weight,
			Height: storedDimensions.Height,
			Length: storedDimensions.Length,
			Width: storedDimensions.Width
		};
	}
}